import React, { useState, useEffect } from 'react';
import { Smartphone, X } from 'lucide-react';
import { useTranslation } from '../../i18n.ts';
import { PHONE_WIDTH_QUERY } from '../../hooks/useTouchLayout.ts';

const DISMISSED_KEY = 'pt_mobile_warning_dismissed';

export default function MobileWarning() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(DISMISSED_KEY);
    if (dismissed) return;

    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(PHONE_WIDTH_QUERY);
    const check = () => setShow(mq.matches);
    check();
    mq.addEventListener('change', check);
    return () => mq.removeEventListener('change', check);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, 'true');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-[var(--color-pt-forest)] flex items-center justify-center p-6">
      <button
        onClick={dismiss}
        className="absolute top-4 right-4 text-white/40 hover:text-white/80 transition-colors"
        aria-label={t('close')}
      >
        <X size={24} />
      </button>
      <div className="text-center max-w-sm">
        <div className="w-16 h-16 rounded-2xl bg-white/10 flex items-center justify-center mx-auto mb-6">
          <Smartphone size={32} className="text-pt-gold" />
        </div>
        <h2 className="text-xl font-black text-white mb-3">{t('mobileWarningTitle')}</h2>
        <p className="text-white/60 text-sm leading-relaxed mb-6">{t('mobileWarningDesc')}</p>
        <button
          onClick={dismiss}
          className="px-6 py-3 bg-pt-gold text-[var(--color-pt-forest)] font-black text-xs uppercase tracking-widest rounded-full hover:bg-pt-gold/90 transition-colors"
        >
          {t('mobileWarningContinue')}
        </button>
      </div>
    </div>
  );
}
